import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, tap, switchMap } from "rxjs/operators";
import { SET_CBOOK_PROGRESS, logError } from "../actions";
var setProgressData = function(completeable, completed, nodes, api) {
    if (nodes) {
        var slideNodes = nodes.filter(function(n) {
            return n.target_type !== "Filter";
        });
        var trackable = slideNodes.filter(function(n) {
            return !n.do_not_track;
        });
        var trackableMaxCharts = trackable.length || 1;
        var trackableVisitedChartsCount = completeable ? trackable.filter(function(n) {
            return completed.indexOf(n.id) > -1;
        }).length : 1;
        var prog = 1 / trackableMaxCharts * trackableVisitedChartsCount;
        var suspendData = api ? api.getSuspendData() : {};
        return {
            e: suspendData.e ? suspendData.e : [],
            f: suspendData.f ? suspendData.f : [],
            kv: suspendData.kv ? suspendData.kv : {},
            p: "".concat(Math.min(100, Math.floor(prog * 100)), "%") || "0%",
            v: suspendData.v ? suspendData.v : []
        };
    } else {
        return {
            e: [],
            f: [],
            kv: {},
            p: "0%",
            v: []
        };
    }
};
export default function setProgress(action$, state$) {
    return action$.pipe(ofType(SET_CBOOK_PROGRESS), tap(function() {
        var suspendData = setProgressData(state$.value.completeable, state$.value.completed, state$.value.nodes, state$.value.api);
        if (state$.value.api) {
            state$.value.api.setSuspendData(suspendData);
        }
    }), switchMap(function() {
        return [];
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "set_suspend_data"
        }));
    }));
}
